// export type Category = { name: string, angle: number };
// export type Categories = [Category, Category, Category, Category];
// export type CategoryIndex = 0|1|2|3;
// export const categories: Categories = [
//   { name: 'Data Science', angle: 10 },
//   { name: 'Languages', angle: -10 },
//   { name: 'Systems', angle: 7 },
//   { name: 'Web Dev', angle: -4 },
// ];

type Mentor = { imageURL: string, name: string, description: string };
const mentors: Mentor[] = [
  {
    imageURL: '/assets/mentor_photos/pablo_aguiar.png',
    name: 'Pablo Aguiar',
    description: "Pablo is a computer scientist working as a lead software engineer at MindYourRights, where he's co-authoring a disruptive, common platform for global music rights management. He's passionate about computer programming, cycling, and coffee. He's been an active open source contributor for at least 15 years, writing mostly in Python, Go, and JavaScript. For the last few years, he found himself in love with Elixir and Rust. He's very excited to return to HackIllinois as a mentor for the 4th consecutive year!",
  },
  {
    imageURL: '/assets/mentor_photos/gino_corrales.jpg',
    name: 'Gino Corrales',
    description: "Gino Corrales is a developer team lead for Caterpillar Inc. in the Cybersecurity Division. Gino was always passionate for mobile wearables, security and software development technologies. Prior to joining Caterpillar, Gino was a mobile developer for State Farm at the University of Illinois Research Park and was responsible for leading a group of interns for almost two years. Gino earned a Computer Science degree from Illinois State University and realized studies of Systems Engineering back at his hometown's university - Universidad Catolica de Santa Maria - in Arequipa, Peru.",
  },
  {
    imageURL: '/assets/mentor_photos/vivek_bhookya.jpg',
    name: 'Vivek Bhookya',
    description: 'CS + Astro 2020 grad -> SDE1 Amzn with 2.6 GPA. I work on an adult-content blocker in my free time, PorNo!, and I am interested in using tech for social and environmental good.\nAsk me anything. GitHub / IG @mrvivacious.',
  },
  {
    imageURL: '/assets/mentor_photos/patrick_gallagher.jpg',
    name: 'Patrick Gallagher',
    description: "I'm a graduating senior who will be starting with Target as a Software Engineer this summer. At U of I, I have been involved with CS 126 for seven semesters, where I helped design MPs, created instructional videos, lectured every now and then, and led too many code reviews to count.",
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Stephen Getty',
    description: 'Alumni of CS @ UIUC 2014.  I work in the defense industry focused on embedded software development. Avid hockey / Chicago Blackhawks fan.',
  },
  {
    imageURL: '/assets/mentor_photos/josh_castor.jpg',
    name: 'Joshua Castor',
    description: "I'm an Advanced Software Engineer at Relativity. I graduated from UIC with a Bachelors in Computer Science on Fall 2018 and have been working at Relativity since 2019. Working on front-end code is my area of expertise and it is also where I tend to have the most fun programming on.",
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Bori Oludemi',
    description: 'Currently a manager/tech lead at Capital One. I love programming and also soccer. Feel free to reach out to me about any of these two topics',
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Bhavani Vegesna',
    description: 'Software engineering from Capital One',
  },
  {
    imageURL: '/assets/mentor_photos/lijian.jpg',
    name: 'Lijian Yu',
    description: 'Senior Data Scientist, Abbvie',
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Heather Huynh',
    description: 'Heather is currently a Software Engineer at Facebook. Previously, she was a Masters student at UIUC with a focus in HCI.',
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Zihao Zhang',
    description: 'Backend Software in GTC center',
  },
  {
    imageURL: '/assets/mentor_photos/noel_johny.jpeg',
    name: 'Noel Johny',
    description: 'I am a IT Analyst at Caterpillar.',
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Ryan Cunningham',
    description: 'A lecturer in CS with experience in digital forensics, security, and bioinformatics. Interested in ethics, law, and policy. A UC Bearcat, UCF Knight, and Fighting Illini.',
  },
  {
    imageURL: '/assets/mentor_photos/default.png',
    name: 'Gaurav Agerwala',
    description: 'I am currently an IIoT Software Engineer at Schlumberger with experience in a variety of software technologies and a passion for problem solving. ',
  },
  {
    imageURL: '/assets/mentor_photos/josh_sanchez.jpg',
    name: 'Joshua Sanchez',
    description: 'UIUC Computer Engineering Senior and CS126 Course Staff. Experienced with embedded systems design, mobile development, web development, and systems programming. Committed full-time to Chicago software startup Quicket Solutions :)',
  },
];

export default mentors;
